module.exports = __webpack_public_path__ + "static/media/21ECLAC1.9428022c.jpg";